import React, { useEffect, useRef, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import SelectSavedTradePlanConfig from '../../forms/tradeplans/SavedTradePlanConfig/SelectSavedTradePlanConfig';
import RenderOptionChains, {
  CreateSubscriptionForOptionChains,
} from '../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/OptionChains';
import Symbol from '../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/Symbol';
import SelectExpirationDates from '../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/ExpirationDates';
import DisplayOptionChoices from '../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/DisplayOptionChoices';
import { Box, Typography } from '@material-ui/core';
import GoLongShort from '../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/GoLongShort';
import QuantityBasis from '../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/QuantityBasis';
import EntryTacticSummaryBox from '../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/EntryTacticSummaryBox';
import PositionTacticSummaryBox from '../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/PositionTacticsSummaryBox';
import ExitTacticSummaryBox from '../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/ExitTacticsSummaryBox';
import PushMessage from '../pushmessages/PushMessage';
import {
  CreateTacticTextField,
  qtyFieldAdornment,
} from '../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/CreateTradePlanTree';
import IncrementDecrementButtonGroup from '../../../utils/componentutils/IncrementDecrementButtonGroup';
import UpDownArrayIncrementDecrement from '../../../utils/componentutils/UpDownArrayIncrementDecrement';
import TextField from '@material-ui/core/TextField';
import ReactHotkeys from 'react-hot-keys';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { dataValidation } from '../../forms/tradeplans/AddTradePlan/DataValidation';
import { addTradePlan } from '../../../stores/websocketStore/utils/outgoingMessages/tradePlan/addtradeplanmessage/addTradePlan';

const boxProps = {
  bgcolor: 'background.paper',
  m: 1,
  borderColor: 'text.primary',
};

const TpFormContextMenu = ({
  finishedRenderingOptionChain,
  setFinishedRenderingOptionChain,
  savedConfigurations,
  setSelectedSavedConfig,
  updatedSavedTp,
  setUpdatedSavedTp,
  //storedEntryConfigurations,
  packageOfSetters,
  //userPreferences,
  setTpDrawerOpen,
  drawerOpen,
  focusRef,
  submitMessageDetails,
  setSubmitMessageDetails,
  clickedSubmit,
  setClickedSubmit,
  symbolsUsed,
  setSymbolsUsed,
  symbolsRemaining,
  mutableSymbol,
  storedConfigKey,
  configTitle,
  top,
  dispatchTop,
  data,
  optionChoices,
  setOptionChoices,
  optionChains,
  setOptionChains,
  expirationDates,
  setExpirationDates,
  notExpiringToday,
  maxOptionPriceBarrier,
  setMaxOptionPriceBarrier,
  minOptionPriceBarrier,
  setMinOptionPriceBarrier,
  tightSpreadPctEnabled,
  tightSpreadPct,
  dispatchTightSpreadPct,
  optionPriceRangeEnabled,
  optionPriceRange,
  dispatchOptionPriceRange,
  qtyRangeEnabled,
  setQtyRangeEnabled,
  dollarRangeEnabled,
  setDollarRangeEnabled,
  qtyRange,
  dispatchQtyRange,
  dollarRange,
  dispatchDollarRange,
  marketOrder,
  dispatchMarketOrder,
  marketOrderEnabled,
  setMarketOrderEnabled,
  candleBreak,
  dispatchCandleBreak,
  candleBreakEnabled,
  setCandleBreakEnabled,
  limitOrder,
  dispatchLimitOrder,
  limitOrderEnabled,
  setLimitOrderEnabled,
  scalingIn,
  dispatchScalingIn,
  scalingInEnabled,
  setScalingInEnabled,
  addToWinner,
  dispatchAddToWinner,
  addToWinnerEnabled,
  setAddToWinnerEnabled,
  lossLimit,
  dispatchLossLimit,
  lossLimitEnabled,
  setLossLimitEnabled,
  preserveProfit,
  dispatchPreserveProfit,
  preserveProfitEnabled,
  setPreserveProfitEnabled,
  positionPriceTrail,
  dispatchPositionPriceTrail,
  positionPriceTrailEnabled,
  setPositionPriceTrailEnabled,
  underlyingPriceTrail,
  dispatchUnderlyingPriceTrail,
  underlyingPriceTrailEnabled,
  setUnderlyingPriceTrailEnabled,
  candleTrail,
  dispatchCandleTrail,
  candleTrailEnabled,
  setCandleTrailEnabled,
  grabCents,
  dispatchGrabCents,
  grabCentsEnabled,
  setGrabCentsEnabled,
  grabCentsMode,
  setGrabCentsMode,
  greenToRedCandles,
  dispatchGreenToRedCandles,
  greenToRedCandlesEnabled,
  setGreenToRedCandlesEnabled,
  greenToRedPositions,
  dispatchGreenToRedPositions,
  greenToRedPositionsEnabled,
  setGreenToRedPositionsEnabled,
  breakPrice,
  dispatchBreakPrice,
  breakPriceEnabled,
  setBreakPriceEnabled,
  positionBreakPrice,
  dispatchPositionBreakPrice,
  positionBreakPriceEnabled,
  setPositionBreakPriceEnabled,
  candleMagnitude,
  dispatchCandleMagnitude,
  setCandleMagnitudeEnabled,
  candleMagnitudeEnabled,
  ratchetBracket,
  dispatchRatchetBracket,
  ratchetBracketEnabled,
  setRatchetBracketEnabled,
  setupDetails,
  dispatchSetUpDetails,
  savedConfigChanged,
  setSavedConfigChanged,
  atrTrail,
  dispatchAtrTrail,
  atrTrailEnabled,
  setAtrTrailEnabled,
  mfeRetracementEnabled,
  setMfeRetracementEnabled,
  mfeRetracement,
  dispatchMfeRetracement,
  underlyingPriceExitEnabled,
  setUnderlyingPriceExitEnabled,
  underlyingPriceExit,
  dispatchUnderlyingPriceExit,
}) => {
  let goLongShortCut = 'alt+l';
  let goShortShortCut = 'alt+s';
  let closeFormShortCut = 'esc';
  let enterTpShortCut = 'enter';
  let shortcutKeyActions = {
    [goLongShortCut]: { action: () => dispatchTop({ goLong: !top.goLong }) },
    [goShortShortCut]: { action: () => dispatchTop({ goShort: !top.goShort }) },
    [closeFormShortCut]: {
      action: () => {
        console.log('drawerOpen:' + drawerOpen);
        setTpDrawerOpen(false);
      },
    },
    [enterTpShortCut]: { action: (evt) => EnterTradePlan(evt) },
  };

  const onKeyDown = (keyName, e, handle) => {
    shortcutKeyActions[keyName].action(e);
  };

  function EnterTradePlan(evt) {
    //HERE HAVE A WAIT
    //key.wait
    //if (submitFunction === AddTradePlan) {
    let [validForm, message] = dataValidation(
      data,
      symbolsRemaining,
      finishedRenderingOptionChain
    );
    if (!validForm) {
      //alert(message);
      evt.preventDefault();
      setClickedSubmit(true);
      setSubmitMessageDetails({ severityScore: 'error', message: message });
      return;
    }
    //}
    evt.preventDefault();
    if (data.optionManagement !== undefined) {
      data.optionManagement.notExpiringToday = undefined; //this is ONLY so frontend can use this. no need to pass to backend
    }
    //provide datasource so tradeplan can setup options from within json converter
    if (data.optionManagement !== undefined) {
      if (data.optionManagement.optionChoices !== undefined) {
        data.optionManagement.optionChoices.dataSource = data.dataSource;
      }
    }
    if (!savedConfigChanged) {
      data['useSavedConfigTitleForDisplay'] = true;
    }
    // if (!savedConfigChanged) {
    data['savedConfigurationTitle'] = configTitle;
    //}
    addTradePlan({
      tradePlanObject: data,
      key: storedConfigKey,
      configName: configTitle,
    });
    setClickedSubmit(true);
    setSubmitMessageDetails({ severityScore: 'success', message: 'submitted' });
  }

  if (!drawerOpen) {
    return <></>;
  }
  return (
    <>
      <ReactHotkeys
        keyName={
          goLongShortCut +
          ',' +
          goShortShortCut +
          ',' +
          closeFormShortCut +
          ',' +
          enterTpShortCut
        }
        onKeyDown={onKeyDown}
        disabled={!drawerOpen}
      >
        <Grid item xs={1}>
          <ExitToAppIcon
            variant="contained"
            color="error"
            onClick={() => setTpDrawerOpen(false)}
            size={'small'}
          />
        </Grid>
        <form
          align-content="left"
          id="tpForm"
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
          }}
          onChange={(e) => {
            if (!savedConfigChanged) {
              setSavedConfigChanged(true);
            }
          }}
        >
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            // alignItems="center"
            spacing={0}
          >
            <Grid item>
              <br />
            </Grid>

            <Grid item container>
              <Grid item xs={2}>
                <SelectSavedTradePlanConfig
                 // defaultSavedConfigKey={
                  //  userPreferences['userPreferences'][
                    //  'defaultSavedTpConfigKey'
                    //]
                 // }
                  packageOfSetters={packageOfSetters}
                  mutableSymbol={mutableSymbol}
                  savedConfigurations={savedConfigurations}
                  setSelectedSavedConfig={setSelectedSavedConfig}
                  updatedSavedTp={updatedSavedTp}
                  setUpdatedSavedTp={setUpdatedSavedTp}
                  focusRef={focusRef}
                  savedConfigChanged={savedConfigChanged}
                  setSavedConfigChanged={setSavedConfigChanged}
                />
              </Grid>
            </Grid>
            <Grid item container>
              <Grid item xs={1}>
                <Symbol
                  top={top}
                  dispatchTop={dispatchTop}
                  componentSymbol={mutableSymbol}
                  setOptionChoices={setOptionChoices}
                  setOptionChains={setOptionChains}
                  finishedRenderingOptionChain={finishedRenderingOptionChain}
                  setFinishedRenderingOptionChain={
                    setFinishedRenderingOptionChain
                  }
                />
              </Grid>
              <Grid item xs={2}>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="stretch"
                  border={1}
                  {...boxProps}
                >
                  <GoLongShort
                    top={top}
                    dispatchTop={dispatchTop}
                    usedSymbols={[symbolsUsed, setSymbolsUsed]}
                  />
                </Box>
              </Grid>
              <Grid item xs={2}>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="stretch"
                  border={1}
                  {...boxProps}
                >
                  <QuantityBasis
                   // defaultQtyBasis={storedEntryConfigurations.qtyBasisValues}
                    top={top}
                    dispatchTop={dispatchTop}
                    marketOrder={[
                      marketOrder,
                      dispatchMarketOrder,
                      marketOrderEnabled,
                      setMarketOrderEnabled,
                    ]}
                    candleBreak={[
                      candleBreak,
                      dispatchCandleBreak,
                      candleBreakEnabled,
                      setCandleBreakEnabled,
                    ]}
                    limitOrder={[
                      limitOrder,
                      dispatchLimitOrder,
                      limitOrderEnabled,
                      setLimitOrderEnabled,
                    ]}
                    scalingIn={[
                      scalingIn,
                      dispatchScalingIn,
                      scalingInEnabled,
                      setScalingInEnabled,
                    ]}
                    addToWinner={[
                      addToWinner,
                      dispatchAddToWinner,
                      addToWinnerEnabled,
                      setAddToWinnerEnabled,
                    ]}
                    lossLimit={[
                      lossLimit,
                      dispatchLossLimit,
                      lossLimitEnabled,
                      setLossLimitEnabled,
                    ]}
                    preserveProfit={[
                      preserveProfit,
                      dispatchPreserveProfit,
                      preserveProfitEnabled,
                      setPreserveProfitEnabled,
                    ]}
                    positionPriceTrail={[
                      positionPriceTrail,
                      dispatchPositionPriceTrail,
                      positionPriceTrailEnabled,
                      setPositionPriceTrailEnabled,
                    ]}
                    underlyingPriceTrail={[
                      underlyingPriceTrail,
                      dispatchUnderlyingPriceTrail,
                      underlyingPriceTrailEnabled,
                      setUnderlyingPriceTrailEnabled,
                    ]}
                    candleTrail={[
                      candleTrail,
                      dispatchCandleTrail,
                      candleTrailEnabled,
                      setCandleTrailEnabled,
                    ]}
                    atrTrail={[
                      atrTrail,
                      dispatchAtrTrail,
                      atrTrailEnabled,
                      setAtrTrailEnabled,
                    ]}
                    underlyingPriceExit={[
                      underlyingPriceExitEnabled,
                      setUnderlyingPriceExitEnabled,
                      underlyingPriceExit,
                      dispatchUnderlyingPriceExit,
                    ]}
                    mfeRetracement={[
                      mfeRetracementEnabled,
                      setMfeRetracementEnabled,
                      mfeRetracement,
                      dispatchMfeRetracement,
                    ]}
                    grabCents={[
                      grabCents,
                      dispatchGrabCents,
                      grabCentsEnabled,
                      setGrabCentsEnabled,
                      grabCentsMode,
                      setGrabCentsMode,
                    ]}
                    greenToRedCandles={[
                      greenToRedCandles,
                      dispatchGreenToRedCandles,
                      greenToRedCandlesEnabled,
                      setGreenToRedCandlesEnabled,
                    ]}
                    greenToRedPositions={[
                      greenToRedPositions,
                      dispatchGreenToRedPositions,
                      greenToRedPositionsEnabled,
                      setGreenToRedPositionsEnabled,
                    ]}
                    breakPrice={[
                      breakPrice,
                      dispatchBreakPrice,
                      breakPriceEnabled,
                      setBreakPriceEnabled,
                    ]}
                    positionBreakPrice={[
                      positionBreakPrice,
                      dispatchPositionBreakPrice,
                      positionBreakPriceEnabled,
                      setPositionBreakPriceEnabled,
                    ]}
                    candleMagnitude={[
                      candleMagnitude,
                      dispatchCandleMagnitude,
                      candleMagnitudeEnabled,
                      setCandleMagnitudeEnabled,
                    ]}
                    ratchetBracket={[
                      ratchetBracket,
                      dispatchRatchetBracket,
                      ratchetBracketEnabled,
                      setRatchetBracketEnabled,
                    ]}
                  />
                </Box>
              </Grid>
              <Grid item xs={1}>
                <QuantityBasisValue
                  top={top}
                  entryTactics={data['entryTactics']}
                  qtyBasis={top.quantityBasis}
                  dispatchMarketOrder={dispatchMarketOrder}
                  dispatchLimitOrder={dispatchLimitOrder}
                  dispatchCandleBreak={dispatchCandleBreak}
                />
              </Grid>
              {top.setup === 'BOUNCE' || top.setup === 'BREAK' ? (
                <>
                  <Grid item xs={1}>
                    <SetupBreakBounceTextField
                      setup={top.setup}
                      price={setupDetails[top.setup].priceToBreak}
                      setPriceToBreak={(price) =>
                        dispatchSetUpDetails({ priceToBreak: price })
                      }
                    />
                  </Grid>
                </>
              ) : (
                <></>
              )}
              <Grid item xs={1}>
                <EntryTacticSummaryBox
                  marketOrder={data.entryTactics.MARKET_ORDER}
                  limitOrder={data.entryTactics.LIMIT_ORDER}
                  candleBreak={data.entryTactics.CANDLE_BREAK}
                />
              </Grid>
              <Grid item xs={1}>
                <PositionTacticSummaryBox
                  addToWinner={
                    data.positionTactics !== undefined
                      ? data.positionTactics.ADD_TO_WINNER
                      : undefined
                  }
                  scalingIn={
                    data.positionTactics !== undefined
                      ? data.positionTactics.SCALING_IN
                      : undefined
                  }
                />
              </Grid>
              <Grid item xs={3}>
                <ExitTacticSummaryBox
                  lossLimit={data.exitTactics.LOSS_LIMIT}
                  preserveProfit={data.exitTactics.PRESERVE_PROFIT}
                  underlyingPriceTrail={data.exitTactics.UNDERLYING_PRICE_TRAIL}
                  positionPriceTrail={data.exitTactics.POSITION_PRICE_TRAIL}
                  candleTrail={data.exitTactics.CANDLE_TRAIL}
                  grabCents={data.exitTactics.GRAB_CENTS}
                  atrTail={data.exitTactics.ATR_TRAIL}
                  underlyingPriceExit={data.exitTactics.UNDERLYING_PRICE_EXIT}
                  greenToRedCandles={data.exitTactics.GREEN_TO_RED_CANDLES}
                  greenToRedPositions={data.exitTactics.GREEN_TO_RED_POSITIONS}
                  breakPrice={data.exitTactics.BREAK_PRICE}
                  positionBreakPrice={data.exitTactics.POSITION_BREAK_PRICE}
                  ratchetBracket={data.exitTactics.RATCHET_BRACKET}
                  mfeRetracement={data.exitTactics.MFE_RETRACEMENT}
                />
              </Grid>
              {data.instrument === 'option' ? (
                <>
                  <Grid item xs={1}>
                    <SelectExpirationDates
                      symbol={top.symbol}
                      dataSource={top.dataSource}
                      brokerage={top.brokerage}
                      expirationDates={expirationDates}
                      setExpirationDates={setExpirationDates}
                      notExpiringToday={notExpiringToday}
                      symbolsUsed={symbolsUsed}
                      setSymbolsUsed={setSymbolsUsed}
                      isMulti={true}
                      numOfDefaultSelected={2}
                      setOptionChains={setOptionChains}
                      startingIndex={0}
                      showStrikesMessage={false}
                      highBarrier={maxOptionPriceBarrier}
                      setHighBarrier={setMaxOptionPriceBarrier}
                      lowBarrier={minOptionPriceBarrier}
                      setLowBarrier={setMinOptionPriceBarrier}
                      hideSelect={true}
                      //fetch={props.fetch}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <RenderOptionChains
                      top={top}
                      expirationDates={expirationDates}
                      optionChoices={[optionChoices, setOptionChoices]}
                      setSymbolsUsed={setSymbolsUsed}
                      optionChains={[optionChains, setOptionChains]}
                      selectSingle={false}
                      displayOptionComponent={DisplayOptionChoices}
                      tightSpread={[
                        tightSpreadPctEnabled,
                        tightSpreadPct,
                        dispatchTightSpreadPct,
                      ]}
                      optionPriceRange={[
                        optionPriceRangeEnabled,
                        optionPriceRange,
                        dispatchOptionPriceRange,
                      ]}
                      showSelectedOptions={false}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <CreateSubscriptionForOptionChains
                      symbol={top.symbol}
                      brokerage={top.brokerage}
                      dataSource={top.dataSource}
                      expirationDates={expirationDates}
                      optionChains={[optionChains, setOptionChains]}
                      finishedRenderingOptionChain={
                        finishedRenderingOptionChain
                      }
                      setFinishedRenderingOptionChain={
                        setFinishedRenderingOptionChain
                      }
                    />
                  </Grid>
                </>
              ) : (
                <></>
              )}
            </Grid>
            <input
              //onKeyPress="return event.keyCode!=13"
              type="submit"
              className="btn btn-primary m-2 addTradePlan"
              value={'CREATE TRADE PLAN'}
              onClick={EnterTradePlan}
            />
            <Grid />
          </Grid>
          {
            <PushMessage
              message={submitMessageDetails['message']}
              severityScore={submitMessageDetails['severityScore']}
              open={clickedSubmit}
              setOpen={setClickedSubmit}
            />
          }
        </form>
      </ReactHotkeys>
    </>
  );
};
const QuantityBasisValue = ({
  top,
  entryTactics,
  qtyBasis,
  dispatchMarketOrder,
  dispatchLimitOrder,
  dispatchCandleBreak,
}) => {
  const [qtyBasisValue, setQtyBasisValue] = useState();

  useEffect(() => {
    if (entryTactics['MARKET_ORDER'] !== undefined) {
      setQtyBasisValue(entryTactics['MARKET_ORDER']['quantityBasisValue']);
    } else if (entryTactics['LIMIT_ORDER'] !== undefined) {
      setQtyBasisValue(entryTactics['LIMIT_ORDER']['quantityBasisValue']);
    } else if (entryTactics['CANDLE_BREAK'] !== undefined) {
      setQtyBasisValue(entryTactics['CANDLE_BREAK']['quantityBasisValue']);
    }
  }, [entryTactics]);
  const handleChange = (value) => {
    if (entryTactics['MARKET_ORDER'] !== undefined) {
      dispatchMarketOrder({
        quantityBasisValue: parseFloat(value),
      });
    } else if (entryTactics['LIMIT_ORDER'] !== undefined) {
      dispatchLimitOrder({
        quantityBasisValue: parseFloat(value),
      });
    } else if (entryTactics['CANDLE_BREAK'] !== undefined) {
      dispatchCandleBreak({
        quantityBasisValue: parseFloat(value),
      });
    }
  };

  let adornment = qtyFieldAdornment(top);

  let keyActionQtyBasis = (ev) =>
    UpDownArrayIncrementDecrement(
      ev.key,
      1,
      parseInt(qtyBasisValue),
      (quantityBasisValue) => handleChange(quantityBasisValue),
      0
    );

  let inputProps = {
    endAdornment: adornment,
    onKeyDown: keyActionQtyBasis,
  };

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="stretch"
        border={1}
        //   padding = {.1}
        {...boxProps}
      >
        <Grid container>
          <Grid item xs={8}>
            <CreateTacticTextField
              label={qtyBasis === undefined ? 'quantity basis value' : qtyBasis}
              defaultValue={qtyBasisValue}
              onBlurFunc={(ev) => handleChange(ev.target.value)}
              props={inputProps}
            />
          </Grid>
          <Grid item xs={1}>
            <IncrementDecrementButtonGroup
              incrementAmount={1}
              currentValue={parseFloat(qtyBasisValue)}
              setter={(quantityBasisValue) => handleChange(quantityBasisValue)}
              roundDecimals={0}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

const SetupBreakBounceTextField = ({ setup, price, setPriceToBreak }) => {
  const [inputValue, setInputValue] = useState(price);
  useEffect(() => {
    setInputValue(price);
  }, [price]);
  return (
    <>
      <TextField
        value={inputValue}
        variant="outlined"
        size="small"
        style={{ backgroundColor: 'white', width: '100%' }}
        onChange={(ev) => setInputValue(ev.target.value)}
        onBlur={(ev) => setPriceToBreak(parseFloat(ev.target.value))}
        label={
          <Typography style={{ fontSize: 10 }}>
            {setup === 'BREAK' ? 'break' : 'bounce'} price
          </Typography>
        }
      >
        <Typography style={{ fontSize: 1 }}>{inputValue}</Typography>
      </TextField>
    </>
  );
};

export default TpFormContextMenu;
